import { AxiosResponse } from 'axios';
import api from './api';
import { PaginationLinks, PaginationMeta } from '../models/Paginator';

export interface User {
  id: number
  name: string,
  surname: string,
  is_invoice_mode_enabled: boolean
}

export interface RegisterUser {
  name: string
  surname: string
  mail?: string
  user_roles?: string
  is_invoice_mode_enabled?: boolean
  password?: string
  password_repeat?: string
}

export interface EditUser {
  id: number
  name: string
  surname: string
  is_invoice_mode_enabled?: boolean
  password?: string
  password_repeat?: string
}

export interface UserResponse {
  id: number
  name: string
  surname: string
  mail: string
  is_invoice_mode_enabled: boolean
  user_roles: string
  administrator_certification: boolean
}

export interface UsersResponse {
  data: UserResponse[]
  meta: PaginationMeta
  links: PaginationLinks
}

export interface Users {
  data: User[]
}

type UserDelete = '';

const get = async (page: number): Promise<AxiosResponse<UsersResponse>> => api.get<UsersResponse>(`/v1/users?page=${page}`);

export const post = async (data: RegisterUser): Promise<AxiosResponse<RegisterUser>> => api.post<RegisterUser>('/v1/users', { ...data });

export const put = async (data: EditUser): Promise<AxiosResponse<RegisterUser>> => api.patch<RegisterUser>(`/v1/users/${data.id}`, {
  name: data.name,
  surname: data.surname,
  is_invoice_mode_enabled: data.is_invoice_mode_enabled,
  password: data.password || undefined,
  password_repeat: data.password_repeat || undefined,
});

export const destroy = async (user_id: number) => api.delete<UserDelete>(`/v1/users/${user_id}`);

export default {
  get,
  post,
  put,
  destroy,
};
